module.exports = __webpack_public_path__ + "img/bgsignin.f29c668b.png";